import { CopilotKit } from "@copilotkit/react-core";
import { ContextProvider } from "./provider";
import type { ChatState } from "./state";

export const RedeemCopilotContext = ({
	runtimeUrl,
	enableAnalytics = false,
	initialChatState,
	instructions,
	children,
}: {
	runtimeUrl: string;
	enableAnalytics?: boolean;
	initialChatState?: Partial<ChatState>;
	instructions?: string;
	children?: React.ReactNode;
}) => {
	return (
		<CopilotKit runtimeUrl={runtimeUrl} showDevConsole={false}>
			<ContextProvider
				enableAnalytics={enableAnalytics}
				initialChatState={initialChatState}
				instructions={instructions}
			>
				{children}
			</ContextProvider>
		</CopilotKit>
	);
};
